(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptController', ReceiptController);

    ReceiptController.$inject = ['$scope', '$state' , '$filter', 'CONST_RECEIPT', 'CONST_COMMON', 'CommonService', 'GLOBAL_URL' , 'ReceiptService', 'FileNetService', '$window', '$timeout', '$uibModal', 'authExpiredInterceptor'];

    function ReceiptController ($scope,  $state, $filter, CONST_RECEIPT, CONST_COMMON, CommonService, GLOBAL_URL, ReceiptService, FileNetService, $window, $timeout, $uibModal, authExpiredInterceptor) {
    	var receiptCtr = this;
    	var self = $scope;
    	self.receipt = {countSubmit : 0};
    	self.CONST_RECEIPT = CONST_RECEIPT;
    	self.title = '';
    	self.txnId = null;
    	self.regex = CONST_RECEIPT.REGEX;
    	// Init control
    	receiptCtr.receiptAgDate = new Date();
    	receiptCtr.inState = function(state){
    	   return $state.includes(state);
    	}
    	
    	receiptCtr.goByTransactionType = function(){
    		if(self.receipt.transaction.txnType === CONST_RECEIPT.TRANSACTION_TYPE_PROPOSAL){
    			$state.go(CONST_RECEIPT.STATE_INDIVIDUAL);
    		}else if(self.receipt.transaction.txnType === CONST_RECEIPT.STATE_POLICY_REVERSAL){
    			$state.go(CONST_RECEIPT.STATE_POLICY_REVERSAL);
    		}
    		else{
    			$state.go(CONST_RECEIPT.STATE_POLICY);
    		}
    	}   	
    	receiptCtr.goByCustomerType = function(){
			//Get product component
			self.product = {};
			self.products = CommonService.query({masterurl:'products'});

    		if(self.receipt.proposal.customer.customerType === CONST_RECEIPT.CUSTOMER_TYPE_INDIVIDUAL){
    			$state.go(CONST_RECEIPT.STATE_INDIVIDUAL);
    		}else{
    			$state.go(CONST_RECEIPT.STATE_CORPORATION);
    		}
    	}
    	//Get product component
    	self.product = {};
    	self.products = CommonService.query({masterurl:'products'});
    	
    	// Get payment type
    	self.paymentTypes = CommonService.query({masterurl:'payment-type'});
    	
    	// Get type of organization
    	self.typeOfOrganizations = CommonService.query({masterurl:'organization-type'});
    	// Get recurring charges
    	self.frequencys = CONST_COMMON.PROPOSAL_FREQUENCYS;
    	
    	receiptCtr.today = new Date();
    	
    	receiptCtr.dateOptions = {
		    maxDate: new Date()
		  };	
    	
    	receiptCtr.doPrint = function(receiptId){
    		if(CONST_RECEIPT.TRANSACTION_TYPE_PROPOSAL === self.receipt.transaction.txnType)
    			$window.open(GLOBAL_URL+'api/ga/receipt/print-document/'+receiptId+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
    		else
    			$window.open(GLOBAL_URL + 'api/ga/receipt/print-receipt-policy/'+ receiptId +'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
    	}
    	
    	receiptCtr.doPrintFileNet = function(receiptNum){
    		self.loading = true;
    		FileNetService.get({method:'isExitsInFileNet', receiptNum:receiptNum}, function(result, headers){
    			self.loading = false;
    			if(headers('X-PRUGAGreatApp-error') !== 'filenet.not.found'){
    				$window.open(GLOBAL_URL + 'api/file-net/download?receiptNum='+ receiptNum + '&access_token=' + authExpiredInterceptor.getToken());    			    				
    			}
    		})
    	}
    	
    	receiptCtr.getAllDistrictByProvince = function(){
    		if (self.receipt.proposal.customer.provinceCode != null || self.receipt.proposal.customer.provinceCode != undefined){
    			proposalCtr.lstDistrict = CommonService.query({masterurl:'district',provinceCode:self.receipt.proposal.customer.provinceCode});
    		}else{
    			proposalCtr.lstDistrict = null;
    		}
    	}
    	
        /*
         * Get Agent
         */
    	receiptCtr.getAgent = function(code){
    		if(code == undefined) return;
    		if(code != undefined || code != ''){
    			var numCode = Number(code);
    			if(numCode < 10000000) numCode += 60000000;
    			self.receipt.receiptAgentCode = numCode.toString();
    		}
    		if (self.receipt.receiptAgentCode != undefined && self.receipt.receiptAgentCode.length == 8){
    			self.editForm.receiptAgentCode.$setValidity('checkRuleAgent',false);
    			self.checkAgent = false;
    			ReceiptService.getAgent({uri: 'get-agent',agentCode:self.receipt.receiptAgentCode}, function(result){
    				self.receipt.receiptAgentName = result.agentName;
    				self.receipt.receiptAgentCode = result.agentCode;
    				if(result.gaRankCode != null && result.gaRankCode != undefined && result.gaRankDesc != null && result.gaRankDesc != undefined ){
    					self.receipt.transaction.gaRankCode = result.gaRankCode;
        				self.receipt.transaction.gaRankDesc = result.gaRankDesc;
    				}
    				self.editForm.receiptAgentName.$setValidity('agentIsTerminate',true);

					if(result.agentCode.startsWith('69') || result.agentCode.startsWith('60'))
					{
						// self.products = self.products.filter(function(returnProductsBanca){
						// 									return returnProductsBanca.productCode != 'VL6'});
						for (var i in self.products) {
							if (self.products[i].productCode == 'VL5') {
								self.products[i].productName = 'Sản phẩm bảo hiểm liên kết chung PRU- VỮNG CHẮC';
								break;
							}
						}
					}
					else
					{
						self.products = CommonService.query({masterurl:'products'});
					}

    				/*if(self.receipt.paymentTypeCode === 'CASH')
    					receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
  						      self.receipt.receiptAgNum, 'TR', 
  						      self.receipt.receiptAgentCode, 
  						      self.receipt.receiptAgDate);
    				if(self.receipt.paymentTypeCode !== 'CASH')
    					receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
    							self.receipt.bankReceiptBrNum, 'TR', 
							      self.receipt.receiptAgentCode, 
							      self.receipt.bankReceiptBrDate);*/
    				
    			}, function(error){
    				if(error!= null && error.data != null)
					{
						if(error.data.agentName != null)
							self.receipt.receiptAgentName = error.data.agentName;
						else
							self.receipt.receiptAgentName = null;

						if(self.receipt.receiptAgentCode.startsWith('69') || self.receipt.receiptAgentCode.startsWith('60'))
						{
							// self.products = self.products.filter(function(returnProductsBanca){
							// 									return returnProductsBanca.productCode != 'VL6'});
							for (var i in self.products) {
								if (self.products[i].productCode == 'VL5') {
									self.products[i].productName = 'Sản phẩm bảo hiểm liên kết chung PRU- VỮNG CHẮC';
									break;
								}
							}
						}
						else
						{
							self.products = CommonService.query({masterurl:'products'});
						}
						self.editForm.receiptAgentName.$setValidity('agentIsTerminate',false);
					}
    			});
    		}
    	}
    	
    	receiptCtr.warningTotalThan150m = function(amount, trNum) {
    		self.clearMessage();
    		if(amount != undefined && amount != ''){
    			if(parseFloat(amount) > 150000000 && (trNum == '' || trNum == undefined)) {
					var modalInstance = 
						//show dialog
						$uibModal.open({
							animation : true,
							templateUrl : GLOBAL_URL+ 'partial?uri=ga/receipt/receipt-bigger-150m-dialog',
							controller : 'ReceiptBigger150mDialogController as bigger150mDlgCtr',
							size : 'lg'
					});
    			}
    		}
    	}
    	
    	receiptCtr.getReceiptOnTrrb = function(receiptNum, agentCode, paymentType) {
    		if(receiptNum == undefined || receiptNum == '') return;
    		ReceiptService.get({uri: 'check-receipt-num-on-trrb',receiptNum:receiptNum}, function(result){
    			if (paymentType == 'CASH') {
    				self.editForm.receiptAgNum.$setValidity('receiptNumOnTrrbIsNotExist',true);
    			}else {
    				self.editForm.bankReceiptBrNum.$setValidity('receiptNumOnTrrbIsNotExist',true);
    			}
    			if(result.letOkeys.subString(1,8) != agentCode){
    				var isConfirm = confirm("Phiếu thu [" + result.rDocNum + "] thuộc tư vấn viên [" + result.letOkeys.subString(1,8) + "], nhân viên vui lòng kiểm tra lại. Bạn chắc chắn muốn đi tiếp?”");
    				if (!isConfirm) {
    					if (paymentType == 'CASH') {
    						self.receipt.receiptAgNum = null;
    						return false;
    	    			}else {
    	    				self.receipt.bankReceiptBrNum = null;
    	    				return false;
    	    			}
    				}
    			}
    		}, function(error){
    			if (paymentType == 'CASH') {
    				self.editForm.receiptAgNum.$setValidity('receiptNumOnTrrbIsNotExist',false);
    				return false;
    			}else {
    				self.editForm.bankReceiptBrNum.$setValidity('receiptNumOnTrrbIsNotExist',false);
    				return false;
    			}
    		});
    	}
    	
    	receiptCtr.checkTrRbNum = function(paymentType, trrbNum, trrbType, agentCode, receiptDate) {
    		self.clearMessage();
    		if(trrbNum == undefined || trrbNum == '') return;
    		var filterDate = $filter('date')(receiptDate, 'dd/MM/yyyy')
    		ReceiptService.get({uri: 'check-trrb-num',paymentType:paymentType, trrbNum:trrbNum,trrbType:trrbType,agentCode:agentCode,receiptDate:filterDate}, function(result){
    			if (paymentType == 'CASH') {
    				self.editForm.receiptAgNum.$setValidity('trrbValid',true);
    			}else {
    				self.editForm.bankReceiptBrNum.$setValidity('trrbValid',true);
    			}
    		}, function(error){
    			if (paymentType == 'CASH') {
    				self.editForm.receiptAgNum.$setValidity('trrbValid',false);
    				return false;
    			}else {
    				self.editForm.bankReceiptBrNum.$setValidity('trrbValid',false);
    				return false;
    			}
    		});
    	}
    	
    	self.checkContest = function(receipt){
    		//if(receipt.checkContest){
    			self.loading = true;
    			ReceiptService.post({uri:"check-contest"}, receipt, function(data){
    				self.loading = false;
            		
            		if(data.contestPaymentDto != null && data.contestPaymentDto != undefined){
            			self.contestPayment = data.contestPaymentDto;
            			self.receiptNum = data.receiptNum;
            			$state.go(CONST_RECEIPT.STATE_CONTEST);            			
            		}
            	}, function(error){
            		
            		self.loading = false;
            	});
    		//}else {
    		//	self.loading = false;
    		//}
    	}
    }
})();
